export class Attachments {
    attachmentId: number = 0;
    fileName: string = "";
    dateCreated: Date;
    reportingPeriodId: number = 0;
    uniqueKey: string = "";
    url: string = "";
}
